<template>
    <v-container>
        <v-breadcrumbs class="px-0"></v-breadcrumbs>
        <v-row class="mt-10">
            <v-col>
                <span class="header bold text-tcdc-green text-uppercase"></span>
                <VisitLayout />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ServiceExpandable from "../../components/expandables/ServiceExpandable";
import { mapState } from 'vuex';
import VisitLayout from "../../components/visit_service_area/Visit";
import { BreadcrumbUtil } from "@/util/BreadcrumbUtil";
export default {
    async created() {
        this.items = BreadcrumbUtil.setServiceItem(
            this.items,
            this.branchId,
            this.branchName,
            this.allBranches,
            this.lang
        );
        if (this.$route.params.branch) {
            let params = { branch_id: 0, lang: this.lang };
            let allBranch = [...this.allBranches];
            let all = true;
            allBranch.shift();
            for (const b of allBranch) {
                if (this.$route.params.branch === b.tag_name) {
                    params.branch_id = b.branch_id;
                    if (this.$route.params.branch === 'mini-tcdc') {
                        await this.$store.dispatch('Branch/getMiniByBranch', params);
                        all = false;
                        break;
                    }
                    await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
                    await this.$store.dispatch("Branch/getBranchById", params.branch_id);
                    all = false;
                    break;
                }
            }
            if (all) {
                let params = { branch_id: 0, lang: this.lang };
                await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
            }
        } else {
            if (this.branchId !== 0) {
                let params = { branch_id: 0, lang: this.lang };
                await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", params);
                await this.$store.dispatch("Branch/getBranchById", params.branch_id);
            }
        }
    },
    computed: {
        ...mapState({
            branchName: state => state.Branch.branch_name,
            branchId: state => state.Branch.branch_id,
            allBranches: state => state.Branch.branches,
            lang: state => state.Branch.lang,
            service_area: state => {
                return state.ServiceMenu.service_area
            }
        }),
        branchChanged: function () {
            return this.branchName;
        }
    },
    watch: {
        branchChanged: function () {
            this.items = BreadcrumbUtil.setServiceItem(
                this.items,
                this.branchId,
                this.branchName,
                this.allBranches,
                this.lang
            )
        }
    },
    data: () => ({
        items: [
            {
                text: 'TCDC BANGKOK',
                to: "/home/:branch"
            },
            {
                text: "SERVICE",
                to: "/:branch/service",
            },
            {
                text: "VISIT & SERVICE AREA",
                disabled: true,
            }
        ]
    }),
    components: {
        VisitLayout,
    }
};
</script>

<style></style>
